import SalesStats from './SalesStats';
import SalesOverview from './SalesOverview';
import SalesByCustomCollection from './SalesByCustomCollection';
import PurchaseRatio from './PurchaseRatio';
import ReturnRatio from './ReturnRatio';
import RevenueGenerated from './RevenueGenerated';

import {
    purchaseRatio,
    returnRatio,
    revenueGenerated,
} from '../../ChartData';
import SalesByCategory from './SalesByCategory';

function SalesInsights() {
    return (
        <>
            <SalesStats />

            <div className="flex mt-3 mx-5">
                <SalesOverview />
            </div>

            <div className="grid grid-cols-2 mt-3 gap-3 mx-5">
                <SalesByCategory />

                <SalesByCustomCollection />
            </div>

            {/* <div className="flex mt-3 mx-5">
                <PurchaseRatio 
                    purchaseRatioData={purchaseRatio}
                />
            </div> */}

            {/* <div className="flex mt-3 mx-5">
                <ReturnRatio 
                    returnRatioData={returnRatio}
                />
            </div> */}

            {/* <div className="flex mt-3 mx-5">
                <RevenueGenerated 
                    revenueGeneratedData={revenueGenerated} 
                />
            </div> */}
        </>
    );
}

export default SalesInsights;
